var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongLishijilu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 5.164a.5.5 0 10-1 0v3.333a.5.5 0 00.51.5h3.324a.5.5 0 100-1H8V5.164z",
    fill: "#3F465C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 8a6.5 6.5 0 0111-4.69v-.977a.5.5 0 011 0v2.334a.5.5 0 01-.5.5h-2.334a.5.5 0 010-1h1.278A5.5 5.5 0 1013.5 8a.5.5 0 011 0 6.5 6.5 0 11-13 0z",
    fill: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_lishijilu.3805f823.svg";
export { SvgTongyongLishijilu as ReactComponent };